import styles from "./header.module.css";
import { SystemIcon } from "@justworkshr/milo-components";
import { getCWRedirectUrl } from "utils/helper";
import { ReactElement, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { getMemberUuid } from "utils/idHelpers";

const HeaderDropdown = (): ReactElement => {
  const [toggleHeader, setToggleHeader] = useState(false);
  const { oktaAuth } = useOktaAuth();

  const memberId = getMemberUuid();

  const cwUrl = memberId
    ? `/employee_profile/${memberId}`
    : "/employee_profile/";

  const handleLogout = async () => {
    await oktaAuth.signOut();
  };
  return (
    <>
      <div
        onClick={() => setToggleHeader(!toggleHeader)}
        className={styles.hoverPointer}
        data-testid="header-dropdown-toggler"
      >
        <SystemIcon
          iconName="person"
          color="neutral"
          title="person"
          size="extra-small"
          className={styles.personSvg}
        />
        <SystemIcon
          iconName="caret"
          color="neutral-subtle"
          title="person"
          size="small"
          className={styles.caretSvg}
        />
      </div>
      {toggleHeader && (
        <div className={styles.headerDropdown} data-testid="header-dropdown">
          <div className={styles.headerDropdownItem}>
            <a
              href={getCWRedirectUrl(cwUrl)}
              data-testid="header-dropdown-profile"
            >
              View Profile
            </a>
          </div>
          <div className={styles.headerDropdownItem}>
            <a
              href={getCWRedirectUrl("/account_settings/basic-information")}
              data-testid="header-dropdown-settings"
            >
              Account Settings
            </a>
          </div>
          <div className={styles.headerDropdownItem}>
            <span
              className={styles.spanLink}
              onClick={handleLogout}
              data-testid="header-dropdown-logout"
            >
              Logout
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderDropdown;
